import * as Sentry from '@sentry/react';

const SENTRY_DSN =
  import.meta.env.VITE_SENTRY_DSN ??
  'https://fa45c13990156ef5f76d780cdfb48b63@o4512040003371008.ingest.de.sentry.io/4512040400715856';

Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0,
  environment: import.meta.env.MODE,
  // Only send events in production builds; dev errors stay in the console
  enabled: import.meta.env.PROD,
});

export default Sentry;
